import React from "react";
import PropTypes from "prop-types";

function Table({
  columns,
  items,
  tableClassName,
  trClassName,
  tdClassName,
  thClassName,
  trhClassName,
}) {
  const defPropTransform = (x) => ({ item: x });

  if (!items?.length) {
    return <div>No data available</div>;
  }

  return (
    <table className={tableClassName}>
      <thead data-testid="table-header">
        <tr className={trhClassName}>
          {columns.map((column) => {
            return (
              <th key={column.id} className={thClassName}>
                {column.HeaderRenderer ? <column.HeaderRenderer /> : null}
              </th>
            );
          })}
        </tr>
      </thead>

      <tbody data-testid="table-body">
        {items.map((x) => {
          return (
            <tr key={x.id} className={trClassName}>
              {columns.map((c) => {
                const { id, transformCellProps, CellRenderer } = c;
                const transform = transformCellProps || defPropTransform;
                const cellProps = transform(x);

                return (
                  <td key={id} className={tdClassName}>
                    {CellRenderer ? <CellRenderer {...cellProps} /> : null}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

Table.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      HeaderRenderer: PropTypes.func,
      CellRenderer: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
      transformCellProps: PropTypes.func,
    })
  ),
  trClassName: PropTypes.string,
  tdClassName: PropTypes.string,
  thClassName: PropTypes.string,
  trhClassName: PropTypes.string,
  tableClassName: PropTypes.string,
};

Table.defaultProps = {
  items: [],
  columns: [],
  trClassName: "tw-border-b tw-border-blueGray-200",
  tdClassName: "tw-py-3 tw-pr-2 tw-break-word",
  thClassName: "tw-py-2 tw-pr-2 tw-align-top ",
  trhClassName: "tw-border-b tw-border-primary",
  tableClassName: "tw-w-full tw-overflow-auto",
};

export default Table;
